<template>
  <v-dialog v-model="open" max-width="420" persistent>
    <v-card class="pa-2">
      
      <v-card-title class="d-flex align-start" style="color: #1F4529;">
        <v-icon class="mr-2 mt-1">mdi-delete-empty</v-icon>
        <span class="text-wrap">
          Você deseja excluir este registro?
        </span>
      </v-card-title>

      <v-card-text class="pt-2">
        Ao confirmar, esta alteração não poderá ser desfeita.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          rounded
          variant="flat"
          @click="disagree"
        >
          Cancelar
        </v-btn>

        <v-btn
          rounded
          color="primary"
          variant="elevated"
          @click="agree"
        >
          Confirmar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SystemDialogOptions',

  computed: {
    ...mapState('systemDialogOptions', [
        'open',
        'title',
        'message',
        'type'
    ]),

    icon() {
        return {
            success: 'mdi-checkbox-marked-circle-outline',
            error: 'mdi-alert-circle',
            warning: 'mdi-alert',
            info: 'mdi-information'
        }[this.type]
    },

    iconColor() {
        return {
            success: 'green',
            error: 'red',
            warning: 'orange',
            info: 'blue'
        }[this.type]
    },

    backgroundColor() {
        return {
            success: '#748873',
            error: '#D73535',
            warning: '#FB8C00',
            info: '#2196F3'
        }[this.type]
    }
  },

  methods: {
    ...mapActions('systemDialogOptions', [
      'agree',
      'disagree'
    ])
  }
}
</script>

<style>
.dialog-header-v {
  background-color: #748873;
  height: 110px;

  clip-path: polygon(
    0 0,
    100% 0,
    100% 75%,
    50% 100%,
    0 75%
  );
}

</style>